import { useEffect, useRef, useState } from 'react';
import { getUserProgramsAPI } from './utils/profilePrograms';
import { getUserId } from './helpers';

export const useProfilePrograms = (username: string, userId: number) => {
  const hasFetchedData = useRef(false);
  const [profilePrograms, setProfilePrograms] = useState([]);
  const [profileProgramsLoaded, setProfileProgramsLoaded] = useState(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getUserProgramsAPI(
        username,
        (programs) => {
          setProfilePrograms(programs);
          setProfileProgramsLoaded(true);
        }
      );
      hasFetchedData.current = true;
    }
  }, []);

  return { profilePrograms, profileProgramsLoaded };
};
